// Otokata Connect scope catalogue — hand-mirrored from otokata-core.
//
// Source of truth on the Go side:
//   - Bootstrap default scopes: otokata-core/pkg_webserv/wh_v1_apps.go:127-139
//   - Per-route scope checks:   otokata-core/pkg_webserv/wh_v1_routes.go
//
// If a scope is added or removed on the Go side, update this file too. The UI
// uses this list as the source of options in the credential-create picker; an
// out-of-sync entry would either hide a real scope from users or offer a
// non-existent one that the backend would reject at validation time.

export const SCOPES = [
  { value: "apps:manage", group: "Management", label: "Manage apps & credentials", description: "Mint, list, and revoke API credentials; edit app metadata." },
  { value: "webhooks:manage", group: "Management", label: "Manage webhook endpoints", description: "Register, edit, and delete webhook endpoints and view deliveries." },

  { value: "messages:read", group: "Messages", label: "Read messages", description: "Read messages and message metadata." },
  { value: "messages:send", group: "Messages", label: "Send messages", description: "Enqueue outbound messages." },

  { value: "sessions:read", group: "Sessions", label: "Read sessions", description: "Read OSA session lists and details." },
  { value: "sessions:write", group: "Sessions", label: "Modify sessions", description: "Mutate session state (close, reopen, label)." },

  { value: "contacts:read", group: "Contacts", label: "Read contacts", description: "List and read workspace contacts and groups." },
  { value: "contacts:write", group: "Contacts", label: "Modify contacts", description: "Create and update contacts, manage group membership." },

  { value: "assets:read", group: "Assets", label: "Read media & templates", description: "Fetch media assets and broadcast templates." },
  { value: "assets:write", group: "Assets", label: "Upload media & templates", description: "Upload media; create/edit broadcast templates." },

  { value: "broadcasts:read", group: "Broadcasts", label: "Read broadcasts", description: "Read broadcast campaigns and targets." },
  { value: "broadcasts:write", group: "Broadcasts", label: "Create & cancel broadcasts", description: "Schedule new broadcast campaigns and cancel running ones." },

  { value: "devices:read", group: "Devices", label: "Read devices", description: "List workspace devices and their status." },

  { value: "bots:read", group: "Bots", label: "Read bots", description: "List OSA bots and their configurations." },
  { value: "bots:handover", group: "Bots", label: "Bot ↔ human handover", description: "Toggle a session between bot and human handling." },

  { value: "analytics:read", group: "Analytics", label: "Read analytics", description: "Read workspace analytics aggregates." },
  { value: "analytics:write", group: "Analytics", label: "Manage analytics config", description: "Create/update/delete per-bot analytics configuration (emotion, labeling, stage)." },

  { value: "events:read", group: "Events", label: "Read event log", description: "Query the canonical event log for debugging/replay." },
];

// react-select grouped options: [{label: groupName, options: [...]}, ...].
const GROUP_ORDER = [
  "Management",
  "Messages",
  "Sessions",
  "Contacts",
  "Assets",
  "Broadcasts",
  "Devices",
  "Bots",
  "Analytics",
  "Events",
];

export const SCOPES_GROUPED = GROUP_ORDER.map((g) => ({
  label: g,
  options: SCOPES.filter((s) => s.group === g),
}));

export const SCOPE_BY_VALUE = SCOPES.reduce((acc, s) => {
  acc[s.value] = s;
  return acc;
}, {});
